export default (axios, baseURL) => async (id, firstName, lastName, email) => {
  const url = `/aha/jwt`;
  const axiosConfig = {
    method: 'GET',
    baseURL,
    url,
    params: {
      id,
      firstName,
      lastName,
      email
    }
  };
  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }

  return axiosResponse.data;
};
